// extracted by mini-css-extract-plugin
export default {"reviewSubTitle":"reviewSubTitle_LXq2c","link":"link_FrMwW"};